/**
 * Shared scripts for collection metafield-driven content and product pages.
 * Vanilla JS only (no jQuery) — compatible with deferred scripts and Theme Editor section events.
 */
(function () {
  'use strict';

  if (window.__cxCustomJsLoaded) return;
  window.__cxCustomJsLoaded = true;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function debounce(fn, wait) {
    var t = null;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  /** Inline / metafield HTML */
  window.xtoggle = function (id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.style.display = el.style.display === 'block' ? 'none' : 'block';
  };

  function siblingAccordionContent(fromEl) {
    var p = fromEl.parentElement;
    if (!p) return null;
    var list = Array.prototype.filter.call(p.children, function (n) {
      return n !== fromEl && n.classList && n.classList.contains('accordion-content');
    });
    return list[0] || null;
  }

  function setAccordionItemState(header, open) {
    var content = siblingAccordionContent(header);
    if (!content) return;
    header.classList.toggle('active', open);
    content.style.display = open ? 'block' : 'none';
    content.hidden = !open;
  }

  function initAccordionContainers(root) {
    var scope = root || document;
    var containers = Array.prototype.slice.call(scope.querySelectorAll('.accordion-container'));
    if (scope instanceof Element && scope.matches('.accordion-container')) {
      containers.unshift(scope);
    }
    Array.prototype.forEach.call(containers, function (container) {
      var headers = container.querySelectorAll('.header');
      Array.prototype.forEach.call(headers, function (header, index) {
        setAccordionItemState(header, index === 0);
      });
    });
  }

  function initModals() {
    var triggers = document.querySelectorAll('.js-custom-modal:not([data-custom-modal-bound])');
    Array.prototype.forEach.call(triggers, function (modalTrigger) {
      modalTrigger.dataset.customModalBound = '1';
      var modal = document.getElementById('modal' + modalTrigger.id.slice(-1));
      if (!modal) return;

      var closeButton = modal.querySelector('.close-button');
      var video = modal.querySelector('video');
      var body = document.body;

      function pauseVideo() {
        if (video) video.pause();
      }

      function closeModal() {
        modal.classList.remove('show');
        pauseVideo();
        body.style.overflow = '';
      }

      modalTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        modal.classList.add('show');
        body.style.overflow = 'hidden';
        if (video) {
          try {
            video.currentTime = 0;
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } catch (e) {}
        }
      });

      if (closeButton) {
        closeButton.addEventListener('click', function (event) {
          event.preventDefault();
          closeModal();
        });
      }

      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });
    });
  }

  function wrapOptionsGroups(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var lists = scope.querySelectorAll('ul.options');
    Array.prototype.forEach.call(lists, function (ul) {
      var parent = ul.parentElement;
      if (parent && !parent.classList.contains('optiongroup')) {
        var wrap = document.createElement('div');
        wrap.className = 'optiongroup';
        parent.insertBefore(wrap, ul);
        wrap.appendChild(ul);
      }
    });
  }

  function scheduleWrapOptionsGroups() {
    wrapOptionsGroups(document);
    var attempts = 0;
    var maxAttempts = 20;
    var id = setInterval(function () {
      attempts += 1;
      wrapOptionsGroups(document);
      if (attempts >= maxAttempts) clearInterval(id);
    }, 100);
  }

  (function initBeforeAfterGlobalHandlers() {
    if (window.__customBaGlobalInit) return;
    window.__customBaGlobalInit = true;

    var layouts = [];
    window.__customBaRegisterLayout = function (fn) {
      layouts.push(fn);
    };

    var activeCard = null;
    var activeHandle = null;
    var activeAfter = null;
    var activeRatioRef = null;
    var pointerMoveRaf = null;
    var pendingClientX = null;

    function clamp(v, min, max) {
      return Math.max(min, Math.min(v, max));
    }

    function applyPointerMove(clientX) {
      if (!activeCard || !activeRatioRef || !activeHandle || !activeAfter) return;

      var rect = activeCard.getBoundingClientRect();
      var w = rect.width;
      var half = activeHandle.offsetWidth / 2;
      var x = clamp(clientX - rect.left, half, w - half);
      var newRatio = clamp(x / w, 0, 1);
      activeRatioRef.set(newRatio);

      var line = activeCard.querySelector('.before-after-swiper-line');
      var right = w - x;
      activeAfter.style.clipPath = 'inset(0 ' + right + 'px 0 0)';
      activeHandle.style.left = x + 'px';
      if (line) line.style.left = x + 'px';
      activeHandle.setAttribute('aria-valuenow', String(Math.round(newRatio * 100)));
    }

    window.addEventListener(
      'pointermove',
      function (e) {
        if (!activeCard) return;
        pendingClientX = e.clientX;
        if (pointerMoveRaf != null) return;
        pointerMoveRaf = requestAnimationFrame(function () {
          pointerMoveRaf = null;
          if (pendingClientX != null) applyPointerMove(pendingClientX);
        });
      },
      { passive: true }
    );

    function endDrag() {
      if (!activeCard) return;
      activeCard.classList.remove('is-dragging');
      activeCard = null;
      activeHandle = null;
      activeAfter = null;
      activeRatioRef = null;
      pendingClientX = null;
    }

    window.addEventListener('pointerup', endDrag, { passive: true });
    window.addEventListener('pointercancel', endDrag, { passive: true });

    var onResize = debounce(function () {
      for (var i = 0; i < layouts.length; i++) {
        try {
          layouts[i]();
        } catch (e) {}
      }
    }, 150);
    window.addEventListener('resize', onResize, { passive: true });

    window.__customBaActive = {
      set: function (card, handle, after, ratioRef) {
        activeCard = card;
        activeHandle = handle;
        activeAfter = after;
        activeRatioRef = ratioRef;
      },
      clear: endDrag,
    };
  })();

  function initBeforeAfterSwipers() {
    function clamp(v, min, max) {
      return Math.max(min, Math.min(v, max));
    }

    var cards = document.querySelectorAll('.before-after-swiper:not([data-custom-ba-init])');
    Array.prototype.forEach.call(cards, function (card) {
      card.dataset.customBaInit = '1';

      var after = card.querySelector('.before-after-swiper-after');
      var handle = card.querySelector('.before-after-swiper-handle');
      var line = card.querySelector('.before-after-swiper-line');
      if (!after || !handle || !line) return;

      var ratio = 0.5;

      function layout() {
        var w = card.clientWidth;
        var half = handle.offsetWidth / 2;
        var x = clamp(ratio * w, half, w - half);
        var right = w - x;
        after.style.clipPath = 'inset(0 ' + right + 'px 0 0)';
        handle.style.left = x + 'px';
        line.style.left = x + 'px';
        handle.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
      }

      function setFromClientX(clientX) {
        var rect = card.getBoundingClientRect();
        var w = rect.width;
        var half = handle.offsetWidth / 2;
        var x = clamp(clientX - rect.left, half, w - half);
        ratio = clamp(x / w, 0, 1);
        layout();
      }

      layout();
      window.__customBaRegisterLayout(layout);

      handle.addEventListener(
        'pointerdown',
        function (e) {
          window.__customBaActive.set(
            card,
            handle,
            after,
            {
              get: function () {
                return ratio;
              },
              set: function (val) {
                ratio = val;
              },
            }
          );
          card.classList.add('is-dragging');
          if (handle.setPointerCapture) handle.setPointerCapture(e.pointerId);
          setFromClientX(e.clientX);
          e.preventDefault();
        },
        { passive: false }
      );
    });
  }

  var brandTrackResizeBound = false;
  function initBrandTrack() {
    var track = document.getElementById('brand-track');
    if (!track) return;

    if (!track.dataset.customBrandOrig) {
      track.dataset.customBrandOrig = track.innerHTML;
    }
    var storedOrig = track.dataset.customBrandOrig;

    var mql = window.matchMedia('(prefers-reduced-motion: reduce)');

    function getPXPerSec(vw) {
      var el = document.getElementById('brand-track');
      if (!el) return 120;
      var ds = el.dataset;
      var mobile = parseFloat(ds.speedMobile);
      var global = parseFloat(ds.speed);
      if (vw < 768 && !isNaN(mobile) && mobile > 0) return mobile;
      if (!isNaN(global) && global > 0) return global;
      return 120;
    }

    function build() {
      var el = document.getElementById('brand-track');
      if (!el) return;

      var orig = el.dataset.customBrandOrig || storedOrig;
      if (!orig) {
        el.style.setProperty('--dur', '0s');
        return;
      }

      if (mql.matches) {
        el.innerHTML = orig;
        el.style.setProperty('--dur', '0s');
        return;
      }

      el.innerHTML = orig;

      var vw = window.innerWidth;
      var guard = 0;
      while (el.scrollWidth < vw && guard < 100) {
        el.innerHTML += orig;
        guard += 1;
      }

      el.innerHTML += el.innerHTML;

      var half = el.scrollWidth / 2;
      var dur = Math.max(2, half / getPXPerSec(vw));
      el.style.setProperty('--dur', dur + 's');
    }

    if (!brandTrackResizeBound) {
      brandTrackResizeBound = true;
      window.addEventListener('resize', debounce(build, 150), { passive: true });
      if (mql.addEventListener) mql.addEventListener('change', build);
      else if (mql.addListener) mql.addListener(build);
    }

    build();
  }

  var reviewTrackResizeBound = false;
  function initReviewTrack() {
    var track = document.querySelector('.review-track');
    if (!track) return;

    if (!track.dataset.customReviewOrig) {
      track.dataset.customReviewOrig = (function captureOriginal() {
        var html = '';
        var nodes = track.children;
        for (var i = 0; i < nodes.length; i++) {
          var cls = ' ' + nodes[i].className + ' ';
          if (cls.indexOf(' review-dup ') === -1) html += nodes[i].outerHTML;
        }
        return html;
      })();
    }

    var mq = window.matchMedia ? window.matchMedia('(max-width:1023px)') : null;

    function build() {
      var el = document.querySelector('.review-track');
      if (!el || !el.dataset.customReviewOrig) return;
      var orig = el.dataset.customReviewOrig;
      el.innerHTML = orig;
      if (mq && mq.matches) el.innerHTML += orig;
    }

    if (!reviewTrackResizeBound) {
      reviewTrackResizeBound = true;
      window.addEventListener('resize', debounce(build, 150), { passive: true });
      if (mq) {
        if (mq.addEventListener) mq.addEventListener('change', build);
        else if (mq.addListener) mq.addListener(build);
      }
    }

    build();
  }

  var customCarouselResizeBound = false;
  function initCustomCarousel() {
    var sliders = document.querySelectorAll('.custom-slider');
    if (!sliders.length) return;

    Array.prototype.forEach.call(document.querySelectorAll('.slider-tile'), function (tile) {
      var promo = tile.querySelector('.product-promo');
      var pricing = tile.querySelector('.product-pricing');

      if (promo && pricing && promo.parentElement !== pricing) {
        pricing.appendChild(promo);
      }
    });

    function animateScroll(element, target, duration) {
      var scrollDuration = typeof duration === 'number' ? duration : 300;
      var start = element.scrollLeft;
      var change = target - start;
      var startTime = performance.now();

      function step(currentTime) {
        var elapsed = currentTime - startTime;
        var progress = Math.min(elapsed / scrollDuration, 1);

        element.scrollLeft = start + change * progress;

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    }

    function customSlider() {
      Array.prototype.forEach.call(document.querySelectorAll('.custom-slider'), function (slider) {
        var sliderInner = slider.querySelector('.custom-slider-inner');
        var leftArrow = slider.querySelector('.slideleft');
        var rightArrow = slider.querySelector('.slideright');
        var parent = slider.parentElement;
        var addCard = null;

        if (!sliderInner) return;

        if (parent) {
          addCard = parent.querySelector(':scope > .add-card');
        }
        if (!addCard) {
          var nextEl = slider.nextElementSibling;
          if (nextEl && nextEl.classList.contains('add-card')) addCard = nextEl;
        }

        var sum = 0;
        var widthItems = slider.querySelectorAll(
          '.custom-slider-inner > a, .custom-slider-inner > img, .custom-slider-inner > .inner, .custom-slider-inner > li, .custom-slider-inner > div'
        );

        Array.prototype.forEach.call(widthItems, function (item) {
          var itemWidth;

          if (slider.classList.contains('address')) {
            var widthStyle = window.getComputedStyle(item);
            var widthMarginLeft = parseFloat(widthStyle.marginLeft) || 0;
            var widthMarginRight = parseFloat(widthStyle.marginRight) || 0;
            itemWidth = item.offsetWidth + widthMarginLeft + widthMarginRight;
          } else {
            itemWidth = item.clientWidth;
          }

          sum += itemWidth;
        });

        if (slider.clientWidth > sum) {
          slider.classList.add('no-scroll');
          if (addCard) addCard.classList.add('no-scroll');
        } else {
          slider.classList.remove('no-scroll');
          if (addCard) addCard.classList.remove('no-scroll');
        }

        var liWidth = 0;
        var maxliWidth = 0;
        var slideItems = slider.querySelectorAll(
          '.slider-tile, .custom-slider-inner .product-tile, .custom-slider-inner > img, .custom-slider-inner > .inner, .custom-slider-inner > li'
        );

        Array.prototype.forEach.call(slideItems, function (item) {
          if (liWidth < slider.clientWidth) {
            maxliWidth = liWidth;
          }

          var style = window.getComputedStyle(item);
          var marginLeft = parseFloat(style.marginLeft) || 0;
          var marginRight = parseFloat(style.marginRight) || 0;
          liWidth += item.offsetWidth + marginLeft + marginRight;
        });

        if (maxliWidth <= 0) {
          maxliWidth = slider.clientWidth;
        }

        var updateArrowState = function () {
          var currentScrollLeft = sliderInner.scrollLeft;
          var maxScrollLeft = sliderInner.scrollWidth - sliderInner.clientWidth;

          if (leftArrow) {
            leftArrow.classList.toggle('disabled', currentScrollLeft <= 0);
          }

          if (rightArrow) {
            rightArrow.classList.toggle('disabled', currentScrollLeft >= maxScrollLeft - 1);
          }
        };

        if (leftArrow && !leftArrow.dataset.customCarouselBound) {
          leftArrow.dataset.customCarouselBound = '1';
          leftArrow.addEventListener('click', function () {
            animateScroll(sliderInner, sliderInner.scrollLeft - maxliWidth, 300);
          });
        }

        if (rightArrow && !rightArrow.dataset.customCarouselBound) {
          rightArrow.dataset.customCarouselBound = '1';
          rightArrow.addEventListener('click', function () {
            animateScroll(sliderInner, sliderInner.scrollLeft + maxliWidth, 300);
          });
        }

        if (!sliderInner.dataset.customCarouselScrollBound) {
          sliderInner.dataset.customCarouselScrollBound = '1';
          sliderInner.addEventListener('scroll', updateArrowState, { passive: true });
        }

        updateArrowState();
      });
    }

    requestAnimationFrame(customSlider);

    if (!customCarouselResizeBound) {
      customCarouselResizeBound = true;
      window.addEventListener('resize', debounce(customSlider, 150), { passive: true });
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var label = e.target.closest('.accordion-container label');
      if (label) {
        var thisContent = siblingAccordionContent(label);
        if (!thisContent) return;
        var labelContainer = label.closest('.accordion-container');
        var labelScope = labelContainer || document;
        labelScope.querySelectorAll('.accordion-content').forEach(function (panel) {
          if (panel !== thisContent) {
            panel.style.display = 'none';
            panel.hidden = true;
          }
        });
        labelScope.querySelectorAll('.accordion-container .header, .header').forEach(function (h) {
          h.classList.remove('active');
        });
        thisContent.style.display = 'block';
        thisContent.hidden = false;
        return;
      }

      var header = e.target.closest('.accordion-container .header');
      if (header) {
        var container = header.closest('.accordion-container');
        if (!container) return;

        var sb = document.querySelector('.social-buymoreless');
        if (sb) sb.querySelectorAll('span.checked').forEach(function (s) { s.classList.remove('checked'); });

        var thisContent = siblingAccordionContent(header);
        if (!thisContent) return;

        if (header.classList.contains('active')) {
          setAccordionItemState(header, false);
          return;
        }

        container.querySelectorAll('.header').forEach(function (h) {
          setAccordionItemState(h, h === header);
        });
        return;
      }

      var collapsible = e.target.closest('.collapsible');
      if (collapsible) {
        var panel = collapsible.nextElementSibling;
        if (!panel) return;
        collapsible.classList.toggle('active');
        if (panel.style.maxHeight) {
          panel.style.maxHeight = '';
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      }
    },
    false
  );

  function tabPanelFromHref(xtabs, href) {
    if (!href || href.charAt(0) !== '#') return null;
    var id = href.slice(1);
    if (!id) return null;
    var panel = document.getElementById(id);
    if (panel && xtabs.contains(panel)) return panel;
    try {
      return xtabs.querySelector(':scope > ' + href);
    } catch (e) {
      return null;
    }
  }

  function tabsForAnchor(anchor, href) {
    var nav = anchor.closest('.xtabnav');
    if (!nav) return null;

    var panel = null;
    if (href && href.charAt(0) === '#') {
      panel = document.getElementById(href.slice(1));
    }

    if (panel) {
      var panelTabs = panel.closest('.xtabs');
      if (panelTabs) return panelTabs;
    }

    var sibling = nav.nextElementSibling;
    while (sibling) {
      if (sibling.classList && sibling.classList.contains('xtabs')) return sibling;
      if (sibling.querySelector) {
        var nestedTabs = sibling.querySelector('.xtabs');
        if (nestedTabs) return nestedTabs;
      }
      sibling = sibling.nextElementSibling;
    }

    return document.querySelector('.xtabs');
  }

  function tabNavItemFromAnchor(anchor) {
    var innerItem = anchor.closest('.xtabnav .inner > div');
    if (innerItem) return innerItem;
    return anchor.closest('.xtabnav > div:not(.inner)') || anchor.closest('.xtabnav > li') || anchor.parentElement;
  }

  function initTabsEvents() {
    document.querySelectorAll('.xtabnav a:not([data-custom-tab-bound])').forEach(function (anchor) {
      anchor.dataset.customTabBound = '1';

      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        var href = anchor.getAttribute('href');
        var xtabs = tabsForAnchor(anchor, href);
        if (!xtabs || !href) return;

        var panel = tabPanelFromHref(xtabs, href);
        if (!panel) return;

        Array.prototype.forEach.call(xtabs.querySelectorAll('.xtab'), function (child) {
          var active = child === panel;
          child.classList.toggle('active', active);
          if (active) {
            child.removeAttribute('hidden');
            child.style.display = '';
          } else {
            child.setAttribute('hidden', 'hidden');
            child.style.display = 'none';
          }
          child.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        var navItem = tabNavItemFromAnchor(anchor);
        if (navItem && navItem.parentElement) {
          Array.prototype.forEach.call(navItem.parentElement.children, function (sib) {
            sib.classList.toggle('active', sib === navItem);
          });
        }

        requestAnimationFrame(function () {
          window.dispatchEvent(new Event('resize'));
          panel.dispatchEvent(new CustomEvent('tab:shown', { bubbles: true }));
          if (typeof window.updateSliderArrows === 'function') {
            try {
              window.updateSliderArrows(panel);
            } catch (err) {}
          }
        });
      });
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.ba-section .btn-before, .ba-section .btn-after');
      if (!btn) return;
      var card = btn.closest('.ba-card');
      if (!card) return;
      var layers = card.querySelectorAll('.ba-layer');
      if (layers.length < 2) return;
      var beforeImg = layers[0];
      var afterImg = layers[1];
      var buttons = card.querySelector('.ba-buttons');
      var btnBefore = card.querySelector('.btn-before');
      var btnAfter = card.querySelector('.btn-after');
      if (!btnBefore || !btnAfter) return;

      if (btn.classList.contains('btn-before')) {
        beforeImg.classList.add('active');
        afterImg.classList.remove('active');
        if (buttons) {
          buttons.classList.remove('after');
          buttons.classList.add('before');
        }
        btnBefore.style.color = '#fff';
        btnAfter.style.color = '#000';
      } else {
        afterImg.classList.add('active');
        beforeImg.classList.remove('active');
        if (buttons) {
          buttons.classList.remove('before');
          buttons.classList.add('after');
        }
        btnBefore.style.color = '#000';
        btnAfter.style.color = '#fff';
      }
    },
    false
  );

  function runInits() {
    initModals();
    scheduleWrapOptionsGroups();
    initAccordionContainers();
    initBeforeAfterSwipers();
    initBrandTrack();
    initReviewTrack();
    initCustomCarousel();
    initTabsEvents();
  }

  onReady(runInits);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e && e.target instanceof Element ? e.target : document;
    wrapOptionsGroups(root);
    initModals();
    initAccordionContainers(root);
    initBeforeAfterSwipers();
    initTabsEvents();
    initBrandTrack();
    initReviewTrack();
    initCustomCarousel();
  });

  document.addEventListener('shopify:section:reorder', function () {
    wrapOptionsGroups(document);
    initCustomCarousel();
    initTabsEvents();
  });

  /** Legacy no-ops — behavior is delegated on document */
  window.initAccordionEvents = function () {};
  window.initAccordionContentEvents = function () {};
  window.initAccordionCollapsibleEvents = function () {};
  window.initTabsEvents = initTabsEvents;
})();
